/**
 * Нога Polymarket по рынку: пройдёт ли покупка на эту сумму по нашему стакану.
 *
 * Сайт Polymarket «по рынку» — это тот же лимитный ордер FAK с потолком цены:
 * уровень, где кончается сумма, плюс допуск (1.5 % по умолчанию). Строка
 * говорит, нальёт ли стакан сумму, держится ли плюс на средней цене и не пустит
 * ли допуск сайта цену, где вилки уже нет. Решение 0012.
 */

import { Decimal } from 'decimal.js';
import type { BookLevel } from '../lib/calc';
import type { RowLeg } from '../lib/row';
import { checkMarket, type MarketCheck, type PolyOrder } from '../poly/market';

/** Проверка по стакану. `null` — не биржевая нога, нет стакана или второй ноги. */
export function polyMarketCheck(
  leg: RowLeg,
  other: RowLeg | undefined,
  liveAsks?: readonly BookLevel[] | null,
): MarketCheck | null {
  const book = liveAsks != null && liveAsks.length > 0 ? liveAsks : leg.book;
  if (leg.unit !== 'share' || book === undefined || leg.marketUsd == null) return null;
  if (other === undefined || !(other.rub > 0) || !(other.payout > 0)) return null;
  const model = leg.payoutModel?.kind === 'shares' ? leg.payoutModel : null;
  return checkMarket({
    asks: book,
    usd: leg.marketUsd,
    otherOdds: new Decimal(other.payout).div(other.rub),
    fee: model === null ? {} : { rate: model.rate, exponent: model.exponent },
    ...(leg.tick != null && leg.tick > 0 ? { tick: leg.tick } : {}),
  });
}

export function PolyOrderEdit({
  order,
  onPick,
}: {
  order: PolyOrder;
  onPick: (next: PolyOrder) => void;
}): React.ReactElement {
  return (
    <span className="nx-cur nx-cur--poly">
      <button
        type="button"
        className="nx-cur__btn"
        aria-pressed={order === 'limit'}
        title="лимитный ордер: шары по цене"
        onClick={(event) => {
          event.stopPropagation();
          onPick('limit');
        }}
      >
        лимит
      </button>
      <button
        type="button"
        className="nx-cur__btn"
        aria-pressed={order === 'market'}
        title="рыночный ордер: доллары по стакану"
        onClick={(event) => {
          event.stopPropagation();
          onPick('market');
        }}
      >
        рынок
      </button>
    </span>
  );
}
